import React from 'react'
import { FaHome } from 'react-icons/fa'

function FamilyDetails({ match }) {

    return (
        <>
            <div className='d-flex'>
                <FaHome className='match-detail-icon' />
                <div className='match-detail-title'>Family Details </div>
            </div>
            {match?.familyDetails?.familyType && <div className='d-flex match-detail-info'>
                <div className='fw-bold' style={{color:'black'}}>Family Type:</div>
                <div style={{ marginLeft: 20 }}>{match?.familyDetails?.familyType}</div>
            </div>}
            {match?.familyDetails?.familyLocation && <div className='d-flex match-detail-info'>
                <div className='fw-bold' style={{color:'black'}}>Family Location:</div>
                <div style={{ marginLeft: 20 }}>{match?.familyDetails?.familyLocation}</div>
            </div>}
            {match?.familyDetails?.fatherStatus && <div className='d-flex match-detail-info'>
                <div className='fw-bold' style={{color:'black'}}>Father Status:</div>
                <div style={{ marginLeft: 20 }}>{match?.familyDetails?.fatherStatus}</div>
            </div>}
            {match?.familyDetails?.motherStatus && <div className='d-flex match-detail-info'>
                <div className='fw-bold' style={{color:'black'}}>Mother Status:</div>
                <div style={{ marginLeft: 20 }}>{match?.familyDetails?.motherStatus}</div>
            </div>}
            {match?.familyDetails?.familyValues && <div className='d-flex match-detail-info'>
                <div className='fw-bold' style={{color:'black'}}>Family Values:</div>
                <div style={{ marginLeft: 20 }}>{match?.familyDetails?.familyValues}</div>
            </div>}
            {match?.familyDetails?.familyAffluence && <div className='d-flex match-detail-info'>
                <div className='fw-bold' style={{color:'black'}}>Family Affluence:</div>
                <div style={{ marginLeft: 20 }}>{match?.familyDetails?.familyAffluence}</div>
            </div>}
        </>
    )
}

export default FamilyDetails